import CityPage from "@/components/feature/CityPage";
import { spokaneValleyConfig } from "./data";

export default function SpokaneValleyPage() {
  return <CityPage config={spokaneValleyConfig} />;
}